<q-header-logo [appName]="app" [isSplashPage]="isSplashHeader"> </q-header-logo>
